import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import InputValueProps from '../../../../../prop-types/input-value-props';
import { UnitConversionService } from '../../../../../../../../services/unit-conversion-service';
import Global from '../../../../../../../../store/global-selectors';
import { WeightInput as WeightInputComponent } from 'ui-components/components/weight-input';
import { WeightUnitValues } from '../../../../../../../../enums/weight-unit';
import { useSelector } from 'react-redux';
import { INT_PARAMETER, PARAMETER } from '../../../../../constants/parameter-name-for-update';
import style from './style.module.less';

const WeightInput = ({ inputValueProps, onChange, label }) => {
  const { intParameter, parameter: unitOfMeasure } = inputValueProps ?? {};
  const sellerUnit = useSelector(Global.selectSellerDefaultWeightUnit);
  const defaultUnitAsNumber = WeightUnitValues.indexOf(sellerUnit);
  const parameterAsInt = Number.parseInt(unitOfMeasure, 10);

  // Add comprehensive null checks to prevent TypeError
  let convertedValue = intParameter || 0;

  try {
    if (
      sellerUnit &&
      typeof sellerUnit === 'string' &&
      !Number.isNaN(parameterAsInt) &&
      intParameter !== null &&
      intParameter !== undefined
    ) {
      convertedValue = UnitConversionService.convertValue(intParameter, parameterAsInt, sellerUnit);
    }
  } catch {
    convertedValue = intParameter || 0;
  }

  const onValueChange = useCallback(
    (value) => {
      onChange({
        [INT_PARAMETER]: value,
        [PARAMETER]: unitOfMeasure || defaultUnitAsNumber || 0,
      });
    },
    [onChange, unitOfMeasure, defaultUnitAsNumber],
  );

  return (
    <div className={style['multi-control-row']}>
      <div>{label}</div>
      <div>
        <WeightInputComponent onChange={onValueChange} unit={sellerUnit} weight={convertedValue || 0} />
      </div>
    </div>
  );
};

WeightInput.propTypes = {
  inputValueProps: InputValueProps.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
};

export default WeightInput;
